// Public URLs of the merged locale bundles written by
// scripts/generate-i18n-resources.mjs. `?url` keeps each file a static asset, so
// the JSON is never converted into a JS module; `eager` inlines the URLs as
// string literals here instead of emitting a chunk per language.
const localeUrls = import.meta.glob<string>('./generated/*.json', {
  query: '?url',
  import: 'default',
  eager: true,
});

const PATH_PREFIX = './generated/';
const PATH_SUFFIX = '.json';

// Language tag -> asset URL, e.g. {'pt-br': '/assets/pt-BR-D1zqOj4a.json'}.
// Keys are lowercased to match `supportedLngs`, which is the form i18next asks
// `read()` for under `lowerCaseLng`. The files keep their canonical names.
export const translations: Record<string, string> = Object.fromEntries(
  Object.entries(localeUrls).map(([path, url]) => [
    path.slice(PATH_PREFIX.length, -PATH_SUFFIX.length).toLowerCase(),
    url,
  ])
);